export enum LanguageEnum {
  PL = 'pl',
  EN = 'en',
}
